import { RoutingConfig } from '@spartacus/core';

export const defaultCartRoutingConfig: RoutingConfig = {
  routing: {
    routes: {
      cart: { paths: ['cart'] },
    },
  },
};
